module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fa/fonts/fontawesome-webfont.eot
// module id = 480
// module chunks = 2